/**
 * The one place that turns a bound of a survey range (rooms, area) into a number: an API number, numeric text, or typed digits.
 * Empty, non-numeric, non-finite and anything below 1 is no bound at all: the API accepts whole numbers from 1 up (rooms 1-10, area 20-500).
 */
export const parseRangeBound = (value: number | string | null | undefined) => {
    if (value == null || value === "") return undefined;

    const bound = Number(value);

    return Number.isFinite(bound) && bound >= 1 ? bound : undefined;
};
/**
 * The one place that turns a bound of a survey range (rooms, area) into a number: an API number, numeric text, or typed digits.
 * Empty, non-numeric, non-finite and anything below 1 is no bound at all: the API accepts whole numbers from 1 up (rooms 1-10, area 20-500).
 */
export const parseRangeBound = (value: number | string | null | undefined) => {
    if (value == null || value === "") return undefined;

    const bound = Number(value);

    return Number.isFinite(bound) && bound >= 1 ? bound : undefined;
};
